import {
  clientSuspensionOptOutResponseSchema,
  saasAutoSuspensionResponseSchema,
  suspensionConfigResponseSchema,
  type ClientSuspensionOptOutResponse,
  type SaasAutoSuspensionResponse,
  type SuspensionConfigDto,
  type UpdateSuspensionConfigDto,
} from '@control-center/shared';

import { apiClient } from './api-client';

/** GET /api/admin/suspension-config — política global (AC7). */
export async function fetchSuspensionConfig(): Promise<SuspensionConfigDto> {
  const res = await apiClient.get<unknown>('/api/admin/suspension-config');
  return suspensionConfigResponseSchema.parse(res.data).data;
}

/** PATCH /api/admin/suspension-config — atualiza com optimistic lock (AC8). */
export async function updateSuspensionConfig(
  dto: UpdateSuspensionConfigDto,
): Promise<SuspensionConfigDto> {
  const res = await apiClient.patch<unknown>('/api/admin/suspension-config', dto);
  return suspensionConfigResponseSchema.parse(res.data).data;
}

/** PATCH /api/admin/clients/:id/suspension-opt-out — opt-out por cliente (AC9). */
export async function setClientSuspensionOptOut(
  clientId: string,
  skipAutoSuspension: boolean,
): Promise<ClientSuspensionOptOutResponse> {
  const res = await apiClient.patch<unknown>(`/api/admin/clients/${clientId}/suspension-opt-out`, {
    skip_auto_suspension: skipAutoSuspension,
  });
  return clientSuspensionOptOutResponseSchema.parse(res.data);
}

/** PATCH /api/admin/saas-products/:id/auto-suspension — override por SaaS (AC10). */
export async function setSaasAutoSuspension(
  saasProductId: string,
  autoSuspensionEnabled: boolean,
): Promise<SaasAutoSuspensionResponse> {
  const res = await apiClient.patch<unknown>(
    `/api/admin/saas-products/${saasProductId}/auto-suspension`,
    { auto_suspension_enabled: autoSuspensionEnabled },
  );
  return saasAutoSuspensionResponseSchema.parse(res.data);
}
